import React from "react";
import "./FooterView.css";

const FooterView = () => {
    return (
        <div class="footer">
            <p>© All rights reserved</p>
        </div>
    );
}

export default FooterView;